import { render, staticRenderFns } from "./assist-legal-team-collection.vue?vue&type=template&id=46f4ec9d"
import script from "./assist-legal-team-collection.vue?vue&type=script&lang=ts"
export * from "./assist-legal-team-collection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports